module.exports = __webpack_public_path__ + "img/norway-genitourinary-diseases-male.dcf8c1a5.png";